/**************************************************
 * Nombre:       Tarjetas_Producto_Lateral
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useBotonCantidadTarjeta} from "../Hooks/useBotonCantidadTarjeta";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {useNavigate} from "react-router";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjetas_Producto_Lateral = ({item, cerrar}) => {
    const {sCell} = useResponsive()
    const navigate = useNavigate()
    const {Boton, cantidad} = useBotonCantidadTarjeta({cantidad: item.cantidad, producto: item})


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 0, borderColor: '#00000030', pr: sCell ? 0 : 2, py: 2}}
        >

            <Grid container size={3}>
                <img onClick={() => {
                    cerrar()
                    navigate('/Detalle/' + item.idProducto)
                }} src={item.img} width={'90%'}/>
            </Grid>

            <Grid container size={{xs: 8, sm: 8, md: 8}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>


                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography
                            onClick={() => {
                                cerrar()
                                navigate('/Detalle/' + item.idProducto)
                            }}
                            sx={{
                                fontWeight: 600,
                                lineHeight: 1.1,
                                fontSize: 16,
                                cursor: 'pointer'
                            }}>{`${item.nombre}`}


                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0}}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: 12
                            }}>{`Artesano: ${item.artesano}`}</Typography>


                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-end'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            <Grid container size={{xs: 5, sm: 12, md: 4}}>
                                <Boton/>
                            </Grid>

                            <Grid container size={{xs: 7, sm: 12, md: 8}} sx={{mt: -1, mb: 1}}>
                                <Grid
                                    container
                                    justifyContent={'flex-end'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                >


                                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}>
                                        <Typography
                                            sx={{fontWeight: 600, fontSize: 12, color: '#00000080', lineHeight: 1.1}}>

                                            {item.valorAntes && item.valorAntes > 0 ?

                                                <>

                                <span style={{
                                    paddingLeft: 0,
                                    fontSize: 11,
                                    color: '#00000080',
                                    fontWeight: 400,
                                }}>Antes: {formatoMoneda(item.valorAntes)} c/u</span>
                                                    <br/>
                                                </>

                                                :

                                                ''
                                            }
                                        </Typography>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}>


                                        <Typography sx={{
                                            fontWeight: 600,
                                            fontSize: 14,
                                            lineHeight: 1.1
                                        }}>

                                            {formatoMoneda(cantidad * item.valor)}</Typography>
                                    </Grid>

                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjetas_Producto_Lateral